import { createApi } from '@reduxjs/toolkit/query/react'
import { baseQueryWithHttpStatus } from '../services/baseQuery';

// Define a service using a base URL and expected endpoints
export const kioskStore = createApi({
    reducerPath: 'kioskStore',
    baseQuery: baseQueryWithHttpStatus,
    endpoints: (builder) => ({
        getCompanyThemeDetails: builder.mutation({
            query: (body) => {
                return {
                    url: "kioskBranding/getCompanyThemeDetails/",
                    method: "POST",
                    body: { ...body }
                }
            },
        }),
        checkUserExists: builder.mutation({
            query: (body) => {
                return {
                    url: "kioskBranding/checkUserExists/",
                    method: "POST",
                    body: { ...body }
                }
            },
        }),
        saveUserInfoAndExecuteFlight: builder.mutation({
            query: (body) => {
                return {
                    url: "kioskBranding/saveUserInfoAndExecuteFlight/",
                    method: "POST",
                    body: { ...body }
                }
            },
        }),
        getUserInfoAndAssetExecutionStatus: builder.mutation({
            query: (body) => {
                return {
                    url: "kioskBranding/getUserInfoAndAssetExecutionStatus/",
                    method: "POST",
                    body: { ...body }
                }
            },
        }),
        kioskVerifyOTP: builder.mutation({
            query: (body) => {
                return {
                    url: "kiosk/verifyOTP/",
                    method: "POST",
                    body: { ...body }
                }
            },
        }),
        kioskResendOTP: builder.mutation({
            query: (body) => {
                return {
                    url: "kiosk/resendOTP/",
                    method: "POST",
                    body: { ...body }
                }
            },
        }),
        acceptConsent: builder.mutation({
            query: (body) => {
                return {
                    url: "kiosk/acceptConsent/",
                    method: "POST",
                    body: { ...body }
                }
            },
        }),
        getPhoneVerificationDetails: builder.mutation({
            query: (body) => {
                return {
                    url: "kioskBranding/getPhoneVerificationDetails/",
                    method: "POST",
                    body: { ...body }
                }
            },
        }),
    }),
})

export const {
    useGetCompanyThemeDetailsMutation,
    useCheckUserExistsMutation,
    useSaveUserInfoAndExecuteFlightMutation,
    useGetUserInfoAndAssetExecutionStatusMutation,
    useKioskVerifyOTPMutation,
    useKioskResendOTPMutation,
    useAcceptConsentMutation,
    useGetPhoneVerificationDetailsMutation,
} = kioskStore;